module.exports = __webpack_public_path__ + "b4759d2c8ed6ac4922f6f34444b4ea.svg";